import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBan, faFlag, faInfoCircle, faNewspaper, faPencilAlt, faPhone } from '@fortawesome/free-solid-svg-icons';

import { PaceStatusBadgeComponent } from '../pace-status-badge/pace-status-badge.component';
import {
    PaceNotificationDetailField,
    PaceNotificationDetailHeader,
    PaceNotificationDetailHeaderAction,
} from './pace-notification-detail-header.interface';

/**
 * Presentational header of a notification-details screen: when and for whom the job is, and the
 * detail fields it is described by.
 *
 * Everything it renders comes from {@link PaceNotificationDetailHeader}; what it reports back is
 * which action the user picked — the ones belonging to a field ({@link fieldActionSelect}) and the
 * ones that do not ({@link actionSelect}). Content projected into it fills the third column, which
 * is where the status step button goes.
 */
@Component({
    selector: 'pace-notification-detail-header',
    imports: [FontAwesomeModule, PaceStatusBadgeComponent],
    templateUrl: './pace-notification-detail-header.component.html',
    styleUrls: ['./pace-notification-detail-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaceNotificationDetailHeaderComponent {
    public readonly header = input.required<PaceNotificationDetailHeader>();

    public readonly actionSelect = output<PaceNotificationDetailHeaderAction>();
    public readonly fieldActionSelect = output<PaceNotificationDetailField>();

    public readonly faPencil = faPencilAlt;
    public readonly faBan = faBan;
    public readonly faInfoCircle = faInfoCircle;
    public readonly faNewspaper = faNewspaper;
    public readonly faFlag = faFlag;
    public readonly faPhone = faPhone;
}
